import fetch from 'auth/FetchInterceptor'

const JwtAuthService = {}

JwtAuthService.login = function (data) {
	return fetch({
		url: '/login',
		method: 'post',
		headers: {
      'public-request': 'true'
    },
		data: data
	})
}

JwtAuthService.register = function (data) {
	const fullUrl = window.location.href;

	return fetch({
		url: '/register',
		method: 'post',
		headers: {
      	'public-request': 'true',
		'X-Full-Referer': fullUrl 
    },
		data: data
	})
}

export default JwtAuthService